import { productSupplyParamService } from '../services/product_supply_parameter-service';
import edit_cell_render from '../components/edit_cell_render';
const product_supply_parameter_grid =
{
    vendor_cell_render:(cell:any)=>{
        return edit_cell_render(
            {
            load:productSupplyParamService.getSupplierLookups,
            onChanged:(e:any)=>{
                cell.data.productCode=null;
                cell.data.productName=null;
                cell.data.locationCode=null;
                cell.data.locationName=null;
                cell.data.vendorCode=e.selectedItem.code;
                cell.data.vendorName=e.selectedItem.name;
                }
            })},
    location_cell_render:(cell:any)=>{
        return edit_cell_render(
                {
                load:()=>(productSupplyParamService.getLocationLookups(cell.data.vendorCode)),
                onChanged:(e:any)=>{
                    cell.data.productCode=null;
                    cell.data.productName=null;
                    cell.data.locationCode=e.selectedItem.code;
                    cell.data.locationName=e.selectedItem.name;
                    }
                })},
    product_cell_render:(cell:any)=>{
        return edit_cell_render(
                {
                load:()=>( productSupplyParamService.getProductLookups(cell.data.vendorCode,cell.data.locationCode)),
                onChanged:(e:any)=>{
                    if((cell.component.getDataSource().items() as any[]).filter(x=>x.productCode ===e.selectedItem.code && x.locationCode==cell.data.locationCode).length==0)
                        {
                                    cell.data.productCode=e.selectedItem.code;
                                    cell.data.productName=e.selectedItem.name;
                        }
                        else
                        {
                            cell.data.productCode=null;
                                    cell.data.productName=null;
                            alert("Vendor:["+cell.data.vendorName+"] Location:["+cell.data.locationName+"] Product:["+e.selectedItem.name+"] existed.")
                        }
                    }
                })},
    onEditingStart : (e: any) => {
        
        if (e.column.dataField == "vendorName" || e.column.dataField == "locationName" || e.column.dataField == "productName" ) {
            if(e.data.id !=undefined)
            e.cancel =true;
        }
    }         

}

export default product_supply_parameter_grid;